import dayjs from 'dayjs';
import Link from 'next/link';
import { PopupButton } from '@typeform/embed-react';

import { FC, useEffect, useState } from 'react';

interface SignupComponentProps {
  eventDate: Date;
  signupOpens: Date;
  signupOpen: boolean;
  signupLink: string;
  eventFull: boolean;
  typeformId?: string;
}

const SignupComponent: FC<SignupComponentProps> = ({
  signupLink,
  signupOpen,
  signupOpens,
  eventFull,
  eventDate,
  typeformId,
}) => {
  const textClass =
    'bg-blank-black text-blank-yellow leading-[170%] tracking-[0.03rem] font-[200] font-solina text-[16px] tablet:text-[16px] laptop:text-[18px] desktop:text-[18px] w-fit px-[8px] ml-[0px] laptop:ml-[24px] desktop:ml-[24px]';

  const [currentDate, setCurrentDate] = useState<Date>();
  useEffect(() => {
    setCurrentDate(new Date());
  }, []);
  if (!currentDate) {
    return null;
  }
  if (dayjs(currentDate).isAfter(eventDate)) {
    return null;
  }
  if (eventFull) {
    return (
      <span className={textClass}>
        Sorry, fullt allerede. &nbsp;
        <Link href={signupLink} passHref className="ml-[10px]">
          Venteliste?
        </Link>
      </span>
    );
  }
  if (!signupOpen) {
    return (
      <div className={textClass}>
        Påmeldingen åpner{' '}
        {signupOpens.toLocaleDateString('nb-NO', {
          month: 'long',
          day: '2-digit',
        })}{' '}
        Kl:{' '}
        {signupOpens.toLocaleTimeString('nb-NO', {
          hour: '2-digit',
          minute: '2-digit',
        })}
      </div>
    );
  }
  if (typeformId) {
    return (
      <PopupButton
        id={typeformId}
        className="bg-blank-black text-blank-yellow py-[22px] text-[16px] font-[600] tracking-[0.2rem] leading-[28px] hover:bg-blank-blue-secondary hover:text-blank-black mt-[16px] text-center"
      >
        MELD DEG PÅ!
      </PopupButton>
    );
  }
  return (
    <Link
      href={signupLink}
      passHref
      className="bg-blank-black text-blank-yellow py-[22px] text-[16px] font-[600] tracking-[0.2rem] leading-[28px] hover:bg-blank-blue-secondary hover:text-blank-black mt-[16px] text-center"
    >
      MELD DEG PÅ!
    </Link>
  );
};

export default SignupComponent;
